import React, { useMemo } from 'react'

import { Card, Flex, Icon, StatusBadge, Tooltip } from "@driftt/dds"
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'

import { driftEmptyStateBuilder } from 'components/States'

export const ResearchTopics = ({topics}: { 
  topics: string[] | undefined, 
}) => {
  const EmptyComponent = useMemo(
    () =>
      driftEmptyStateBuilder(
        'No UTM terms found',
        'Not enough activity in the last 2 weeks'
      ),
    []
  )
  return (
    <Card>
      <Card.Header>
        <Flex alignItems='center'>
          UTM Terms
          <Tooltip side='top' content={'Digital campaigns buyers have interacted with in the past 2 weeks'}>
            <Icon icon={faCircleInfo}/>
          </Tooltip>
        </Flex>
      </Card.Header>
      <Flex wrap='wrap'>
        {(!topics || topics.length < 1) && 
          <EmptyComponent/>
        }
        {topics?.map(
          (topic) => {
            return (
              <StatusBadge variant='pending' key={topic}>
                {topic}
              </StatusBadge>
            )
          }
            
        )}
      </Flex>
    </Card>
  )
}